import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) return (
    <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>
  );
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
}
